import { combineReducers } from 'redux'
import { FacebookState, facebookReducer } from './facebook/facebook.reducer'
import { CommonState, CommonReducer } from './common/common.reducer'

export interface ApiError {
  [key: string]: Response | Error | Record<string, unknown> | undefined
}

export interface FacebookSettingsRootState {
  facebookStore: FacebookState
  commonStore: CommonState
}

export const facebookSettingsRootReducer = combineReducers<FacebookSettingsRootState>({
  facebookStore: facebookReducer,
  commonStore: CommonReducer,
})
